import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import { remove } from "lodash";
import { EMAIL_PATTERN } from "../../@auth/components/constants";
import { Supplier } from "../../models/supplier.model";

import { SupplierService } from "../../services/supplier.service";
import { DialogImagesUploadComponent } from "../dialog-images-upload/dialog-images-upload.component";
import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";

@Component({
  selector: "ngx-dialog-supplier",
  templateUrl: "dialog-supplier.component.html",
  styleUrls: ["dialog-supplier.component.scss"],
})
export class DialogSupplierComponent implements OnInit {
  @Input() header: string;
  @Input() mode: string;
  @Input() shopId: string;
  @Input() supplier: Supplier = new Supplier();

  status: string = "0";
  trees: Set<string> = new Set([]);
  diaForm: FormGroup;
  submitted = false;
  loading = false;
  edited = false;
  imageURL = "";
  imagesUrl = [];
  menu = "info";

  constructor(
    protected ref: NbDialogRef<DialogSupplierComponent>,
    private fb: FormBuilder,
    private supplierService: SupplierService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    const fullNameValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const mobileValidators = [Validators.required];
    const stringValidators = [
      Validators.minLength(1),
      Validators.maxLength(500),
    ];
    const emailValidators = [Validators.pattern(EMAIL_PATTERN)];

    this.diaForm = this.fb.group({
      fullName: ["", fullNameValidators],
      description: ["", stringValidators],
      dob: [],
      gender: [],
      mobile: ["", mobileValidators],
      cardId: [],
      email: ["", emailValidators],
      address: ["", stringValidators],
      tax: [],
    });

    if (!this.supplier.dob) {
      this.supplier.dob = new Date();
    }

    if (this.supplier.tags && this.supplier.tags.length > 0) {
      var trees = new Set([]);
      this.supplier.tags.forEach(function (value) {
        trees.add(value);
      });
      this.trees = trees;
    } else {
      this.trees.add("KH");
    }
    if (!this.supplier.sourceType || this.supplier.sourceType == "") {
      this.supplier.sourceType = "document";
    }
    if (!this.supplier.gender) {
      this.supplier.gender = "Khác";
    }
    if (this.supplier.coverUrl && this.supplier.coverUrl != "") {
      this.imageURL = this.supplier.coverUrl;
    }
    if (this.supplier.imagesUrl && this.supplier.imagesUrl.length > 0) {
      this.imagesUrl = _.clone(this.supplier.imagesUrl);
    }
    if (!this.supplier.content) {
      this.supplier.content = "";
    }
  }

  cancel() {
    if (this.edited) {
      this.ref.close(this.supplier);
    } else {
      this.ref.close();
    }
  }

  selectMenu(value) {
    this.menu = value;
  }

  submit() {
    this.submitted = true;

    var tags: string[] = [];
    this.trees.forEach(function (item) {
      tags.push(item);
    });
    this.supplier.tags = tags;
    this.supplier.email = this.supplier.email ? this.supplier.email : "";
    this.supplier.mobile = this.supplier.mobile
      ? this.supplier.mobile.replace(" ", "").trim()
      : "";

    this.supplier.cardId = this.supplier.cardId ? this.supplier.cardId : "";
    this.supplier.coverUrl = this.supplier.coverUrl
      ? this.supplier.coverUrl
      : "";
    this.supplier.fullName = this.supplier.fullName
      ? this.supplier.fullName
      : "";
    if (this.supplier.fullName != "") {
      this.supplier.lastName = this.supplier.fullName.split(" ")[0].trim();
      this.supplier.firstName = this.supplier.fullName
        .replace(this.supplier.lastName, "")
        .trim();
    }
    if (this.supplier.dob) {
      this.supplier.dobYear = new Date(this.supplier.dob).getFullYear();
      this.supplier.dobMonth = new Date(this.supplier.dob).getMonth() + 1;
      this.supplier.dobDay = new Date(this.supplier.dob).getDate();
    }

    this.supplier.gender = this.supplier.gender ? this.supplier.gender : "Khác";
    this.supplier.address = this.supplier.address ? this.supplier.address : "";
    this.supplier.tax = this.supplier.tax ? this.supplier.tax : "";
    this.supplier.description = this.supplier.description
      ? this.supplier.description
      : "";
    this.supplier.tags = this.supplier.tags ? this.supplier.tags : [];
    this.supplier.imagesUrl = this.supplier.imagesUrl
      ? this.supplier.imagesUrl
      : [];

    if (this.mode == "edit") {
      this.edit();
    } else {
      this.create();
    }
  }

  create() {
    this.loading = true;
    this.submitted = true;

    console.log("create:", this.supplier);

    this.supplierService
      .create(this.supplier)
      .then((data) => {
        this.supplier = data;

        this.loading = false;
        this.submitted = false;

        this.ref.close(this.supplier);
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  edit() {
    this.loading = true;
    this.submitted = true;

    this.supplierService
      .update(this.supplier)
      .then((data) => {
        this.loading = false;
        this.submitted = false;

        this.edited = true;
        this.ref.close(this.supplier);
        this.showToast("success", "Cập nhật nhà cung cấp", "thành công");
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
        this.showToast("warning", "Cập nhật nhà cung cấp", "thất bại");
      });
  }

  delete(item: Supplier) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nhà cung cấp này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.supplierService
            .delete(item.shopId, item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.ref.close(this.supplier);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  //Images
  openGallery() {
    this.dialogService
      .open(DialogImagesUploadComponent, {
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.addImage(value);
        }
      });
  }

  updateImage(imageUrl) {
    if (imageUrl && imageUrl != "") {
      this.supplier.coverUrl = imageUrl;
      this.imageURL = imageUrl.replace("_400x400", "");
    }
  }
  removeCoverUrl() {
    this.supplier.coverUrl = "";
    this.imageURL = "/assets/images/image-upload-bg.jpg";
  }

  addImage(obj) {
    let imageURL = obj.value;

    if (!this.supplier.imagesUrl) {
      this.supplier.imagesUrl = [];
    }
    this.supplier.imagesUrl.push(imageURL);

    if (obj.isNew) {
      imageURL = imageURL.replace("_400x400", "");
    }
    this.imagesUrl.push(imageURL);
  }

  deleteImage(item) {
    remove(this.supplier.imagesUrl, (el) => {
      return el == item;
    });
    remove(this.imagesUrl, (el) => {
      return el == item;
    });
  }

  //Tags
  onTagRemove(tagToRemove: NbTagComponent): void {
    this.trees.delete(tagToRemove.text);
  }

  onTagAdd({ value, input }: NbTagInputAddEvent): void {
    if (value) {
      this.trees.add(value);
    }
    input.nativeElement.value = "";
  }

  // control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
